import { Typography } from "@mui/material";

const NoAppointmentsMessage = (): React.JSX.Element => (
  <Typography
    sx={{
      fontWeight: "bold",
      textAlign: "center",
      mt: 2,
    }}
    variant="body1"
    component="p"
  >
    Keine Termine gefunden
  </Typography>
);

export default NoAppointmentsMessage;
